import { Database } from 'lucide-react';
import { chatTheme as th } from '../../theme/chat';

export default function QueryViewer({ query, stepName }) {
  const q = th.workspace.query;

  if (!query || (!query.measures?.length && !query.dimensions?.length && !query.timeDimensions?.length)) {
    return (
      <div className={`px-4 py-4 ${q.bg} ${q.border}`}>
        <p className="text-xs text-zinc-400">No query defined. Use the chat to create one.</p>
      </div>
    );
  }

  return (
    <div className={`${q.bg} ${q.border}`}>
      <div className={`flex items-center gap-2 px-4 py-1.5 ${q.headerBg} border-b border-zinc-100`}>
        <Database size={12} className="text-zinc-400" />
        <span className="text-[11px] font-medium text-zinc-500">Cube Query</span>
        {stepName && <span className="text-[10px] text-zinc-400">&mdash; {stepName}</span>}
      </div>
      <pre className="px-4 py-3 text-xs leading-relaxed font-mono text-zinc-700 overflow-auto" style={{ maxHeight: '200px' }}>
        {query.measures?.length > 0 && (
          <>
            <span className={q.keyword}>measures</span>{'\n'}
            {query.measures.map(m => (
              <span key={m}>{'  '}<span className={q.field}>{m.split('.').pop()}</span>
              <span className={q.comment}>{' // '}{m.split('.')[0]}</span>{'\n'}</span>
            ))}
          </>
        )}
        {query.dimensions?.length > 0 && (
          <>
            {query.measures?.length > 0 && '\n'}
            <span className={q.keyword}>dimensions</span>{'\n'}
            {query.dimensions.map(d => (
              <span key={d}>{'  '}<span className={q.field}>{d.split('.').pop()}</span>
              <span className={q.comment}>{' // '}{d.split('.')[0]}</span>{'\n'}</span>
            ))}
          </>
        )}
        {query.timeDimensions?.length > 0 && (
          <>
            {'\n'}<span className={q.keyword}>time</span>{'\n'}
            {query.timeDimensions.map(td => (
              <span key={td.dimension}>{'  '}<span className={q.field}>{td.dimension.split('.').pop()}</span>
              {td.granularity && <span>{' '}<span className={q.keyword}>by</span> <span className={q.value}>{td.granularity}</span></span>}
              {td.dateRange && <span>{' '}<span className={q.value}>{td.dateRange[0]}</span> <span className={q.operator}>{'\u2192'}</span> <span className={q.value}>{td.dateRange[1]}</span></span>}
              {'\n'}</span>
            ))}
          </>
        )}
        {query.filters?.length > 0 && (
          <>
            {'\n'}<span className={q.keyword}>filters</span>{'\n'}
            {query.filters.map((f, i) => (
              <span key={i}>{'  '}<span className={q.field}>{(f.member || '').split('.').pop()}</span>
              {' '}<span className={q.operator}>{f.operator}</span>
              {' '}<span className={q.value}>{(f.values || []).join(', ')}</span>{'\n'}</span>
            ))}
          </>
        )}
        {query.limit && (
          <>
            {'\n'}<span className={q.keyword}>limit</span> <span className={q.value}>{query.limit}</span>{'\n'}
          </>
        )}
      </pre>
    </div>
  );
}
